// extracted by mini-css-extract-plugin
export default {"cartContainer":"EM","summarycontent":"FM","offset":"GM","leaf":"HM","summaryclosed":"IM","summaryheader":"JM","summaryitems":"KM","summaryprice":"LM","buttonopen":"MM","buttondown":"NM","summaryfixed":"OM","usdnotification":"PM","renew":"QM","promowrapper":"RM","ordersummarywrap":"SM","simplewrap":"TM"};
    if(module.hot) {
      // 1713361652284
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  